// 请求接口前缀（测试环境）
// 这里一般是配置常用数据 测试
// export const ajaxBaseUrl = 'https://testa.link2shops.com/vfuliApi'

// 生产
export const ajaxBaseUrl = 'https://vtravel.link2shops.com/vfuliApi'

// 定义全局渠道id 渠道id
export const channelId = '3f8daaa7588e487dbf953d849f352c94'

// 联系客服
export const customerUrl =
    'https://ykf-webchat.7moor.com/wapchat.html?accessId=2917c160-5ae7-11eb-959c-d5dc3ba23ff8&fromUrl=&urlTitle=&language=ZHCN'



// WEBPACK FOOTER //
// ./src/data/config.js